import TasksModule from '@modules/TasksModule';
import { ITask } from '@modules/TasksModule/types';
import { sanitizePhoneNumberTo10Digits } from '@lib/utils/formatPhone/sanitizePhoneNumberTo10Digits';
import { SPEED_TO_LEAD_OUTBOUND_TASK_TYPE } from '../types';

/**
 * Finds an STL task that matches the given phone number for an outbound call.
 * Requires `hasMadeCall` to be true — ensures we only match after the agent
 * has actually placed a call from the STL task.
 *
 * Both sides are canonicalized to the project's 10-digit form before comparing
 * so the match is not sensitive to formatting differences between BFF payloads
 * and SIP `remoteIdentity` (CCP-39831).
 */
export function findStlTaskForCall(remoteIdentity: string): ITask | undefined {
  if (!remoteIdentity) return undefined;
  const remote = sanitizePhoneNumberTo10Digits(remoteIdentity);
  if (!remote) return undefined;
  return TasksModule.getTasks().find(
    (t) =>
      t.type === SPEED_TO_LEAD_OUTBOUND_TASK_TYPE &&
      t.attributes.hasMadeCall &&
      sanitizePhoneNumberTo10Digits(t.from) === remote,
  );
}
